export { getLocalesFx } from './locales';
export { getMenuFx } from './menu';
